import { createContext, FC, useState } from 'react';
import { getLocalStorage } from '../utils/web-storage-utils';

export type ErrorState = {
  error: Error;
  message: string;
};
export type ErrorStateContextProps = {
  errorState: ErrorState | null;
  setErrorState: React.Dispatch<React.SetStateAction<ErrorState | null>>;
};

export const ErrorStateContext = createContext<ErrorStateContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const ErrorStateProvider: FC<Props> = ({ children }) => {
  const [errorState, setErrorState] = useState<ErrorState | null>(null);

  return <ErrorStateContext.Provider value={{ errorState, setErrorState }}>{children}</ErrorStateContext.Provider>;
};
export default ErrorStateProvider;
